import React, { useState } from 'react';
import '../App.css';

const scenarios = [
  {
    tab: '全病程管理',
    title: '打通院内院外患者数据采集与自动化管理',
    target: '面向：院内治疗、院外康复的慢性病，例如：高血压、糖尿病、心肺疾病、术后康复、母婴、肿瘤等。',
    desc: '整合智能硬件、利用微信生态、解决院外服务管理与数据联动。\n支持院外多模态数据采集、远程生命体征监测，和院内数据集成与治理。\n支持多源异构、多模态数据的结构化处理与存储。\n支持本地化策略的配置与自动执行，满足千人千面的精准随访、长期健康宣教与异常指标预警等。\n医生可按需发起在线互动，有效提升院外管理的质量与效率。',
    imgs: [require('../assets/screen1_image.png'), require('../assets/screen6_image.png')],
  },
  {
    tab: '临床科研创新',
    title: '临床科研的数字化创新与科研成果转化',
    target: '面向：临床科室、科研机构、药企和数字化转型医疗机构。',
    desc: '支持快速构建灵活、可交互的专病数据库，整合临床、影像、组学、ePRO等多维度数据。\n提供基于大模型、机器学习等技术，在图像分割与标柱、AI辅助诊断、疗效预测与数字医生等方向的创新课题设计与研究，加速人工智能与计算机技术的临床研究和成果转化。\n提供单中心、多中心、去中心化的真实世界研究电子病历采集系统，eCRF建库等，为临床科研提供数据服务。',
    imgs: [require('../assets/screen3_image.png'), require('../assets/screen4_image.png')],
  },
  {
    tab: "数字化康复",
    title: "快速开展数字化康复干预的临床实践",
    target: "面向: 术后康复、慢性病（如高血压、糖尿病、心肺疾病）、肿瘤患者及特殊群体（如老年人、母婴）等。",
    desc: "通过数字化康复平台，设计围绕患者个性化康复需求的干预与预警流程，涵盖不良事件监测、运动、营养、心理等多维度的干预内容。\n结合智能设备与移动应用，实时监测患者康复状态，提供精准的康复指导与进度跟踪。\n平台通过数据分析为医生和康复专家提供决策支持，持续优化治疗路径，帮助患者在术后及慢性病管理过程中实现高质量生存，显著提高临床康复结局。",
    imgs: [require('../assets/screen5_image.png')],
  },
  {
    tab: '社区健康服务',
    title: '快速构建标准化、可复制、可推广的健康管理服务',
    target: '面向: 社区卫生服务中心、家庭医生团队、健康管理与服务机构、街道、社区等。',
    desc: '支持建立以用户为中心的电子健康档案管理。\n提供自助可配的问卷调查与量表系统，灵活开展健康风险评估、疾病筛查、预防控制和民意调查等。\n支持平台统一管理，提升公共卫生服务的精准度与覆盖率，做好居民健康"守门人"。',
    imgs: [require('../assets/screen0_image.png'), require('../assets/screen2_image.png')],
  },
];

function ApplicationScenarios() {
  const [active, setActive] = useState(0);
  const descLines = scenarios[active].desc.split('\n');
  return (
    <section id="scenarios">
      <h2>赋能各类医疗健康应用场景，满足您的多样化需求</h2>
      <div className="scenario-tabs">
        {scenarios.map((s, i) => (
          <button
            key={i}
            className={`scenario-tab${active === i ? ' active' : ''}`}
            onClick={() => setActive(i)}
          >
            {s.tab}
          </button>
        ))}
      </div>
      <div className="scenario-panel">
        <div className="scenario-card">
          <div className="scenario-title">{scenarios[active].title}</div>
          <div className="scenario-target" style={{fontWeight: 700, color: '#006622', fontSize: '1.13rem', marginBottom: 16}}>{scenarios[active].target}</div>
          <div className="scenario-desc">
            {descLines.map((line, idx) => (
              <div key={idx} style={{display: 'flex', alignItems: 'flex-start', marginBottom: 8}}>
                <span className="scenario-desc-index" style={{display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 26, height: 26, background: '#003300', color: '#fff', fontWeight: 700, fontSize: '1rem', borderRadius: '50%', marginRight: 12, flexShrink: 0}}>{idx + 1}</span>
                <span style={{flex: 1, minWidth: 0}}>{line}</span>
              </div>
            ))}
          </div>
          <div className={`scenario-imgs-wrap${scenarios[active].imgs.length === 1 ? ' single' : ''}`}>
            {scenarios[active].imgs.map((img, idx) => (
              <img src={img} alt={scenarios[active].title + '-' + idx} className="scenario-img-multi" key={idx} loading="lazy" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
export default ApplicationScenarios; 